import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const SucursalesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")

  const eliminarItem = async (id) => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch(`/api/branches/${id}`,{
        method: "DELETE",
      });
      if (data.status) {
        setDatos([])
        await cargarDatos();
      } else {
        setError(data.message || "No se pudo eliminar la sucursal.");
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || "No se pudo eliminar la sucursal.");
      setIsLoading(false);
    }
  }

  const [datosTabla] = useState({
    titulo: "Sucursales",
    ruta: "/sucursal",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "SUCURSAL", key: "nombre" },
    { title: "CIUDAD", key: "ciudad" },
    { title: "ESTADO", key: "estado" },
    { title: "FECHA ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/branches",{
        method: "GET",
      });
      console.log(data);
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar las sucursales.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar las sucursales.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : (
          <>
            { error && (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            )}
            <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/>
          </>
        )}
      </MasterLayout>
    </>
  );
};

export default SucursalesPage;
